export enum Scope {
  CO_OWNER = 'CO_OWNER',
  SYNDIC = 'SYNDIC',
  SUPERADMIN = 'SUPERADMIN',
  EXTERNAL_PARTICIPANT = 'EXTERNAL_PARTICIPANT',
}
